import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { JobBoardService } from '../../../../shared/services/job-board.service';
import { UserService } from '../../../../shared/services/user.service';
import { UserClientVm } from '../../../../store/user/user.interface';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HeadingComponent } from '../../../../shared/components/heading/heading.component';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-applied-jobs',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, HeadingComponent, TooltipModule, DialogModule],
  templateUrl: './applied-jobs.component.html',
  styleUrls: ['./applied-jobs.component.scss'],
  providers: [DialogService]
})
export class AppliedJobsComponent implements OnInit {
  jobs: any[] = [];
  expandedRows: { [key: string]: boolean } = {};
  user!: UserClientVm;
  ref: DynamicDialogRef | null = null;
  jobsCount = 0;
  page: number = 0;
  rows: number = 10;

  detailModalVisible = false;
  detailModalHeader = '';
  detailModalContent = '';

  constructor(
    private jobBoardService: JobBoardService,
    private userService: UserService,
    private dialogService: DialogService,
    public sanitizer: DomSanitizer
  ) {}

  async ngOnInit() {
    this.user = this.userService.getSessionUser();
    await this.fetchAppliedJobs();
  }

  async fetchAppliedJobs(payloadOverride?: any) {
    const basePayload = {
      candidateId: this.user._id,
      page: this.page,
      limit: this.rows
    };
    const payload = payloadOverride ? { ...basePayload, ...payloadOverride } : basePayload;
    const jobsResponse = await this.jobBoardService.getAppliedJobApplications(payload);

    // jobsResponse is an array, each item has an AppliedJobs array and totalJobCount
    this.jobs = [];
    let totalCount = 0;
    if (Array.isArray(jobsResponse)) {
      jobsResponse.forEach(item => {
        if (Array.isArray(item.AppliedJobs)) {
          this.jobs.push(...item.AppliedJobs);
          if (typeof item.totalJobCount === 'number') {
            totalCount = item.totalJobCount;
          }
        }
      });
    }
    this.jobsCount = totalCount;
  }

  onPageChange(event: any) {
    this.page = event.first / event.rows;
    this.rows = event.rows;
    this.fetchAppliedJobs();
  }

  getLocation(job: any): string {
    if (job.isRemote) return 'Remote';
    if (job.city && job.state && job.postalCode) return `${job.city}, ${job.state}, ${job.postalCode}`;
    return '';
  }

  openDetailModal(job: any, type: 'description' | 'requirement' | 'responsibility') {
    switch(type){
      case 'description':
        this.detailModalContent = job[type] || 'No description available.';
        this.detailModalHeader = 'Description';
        break;
      case 'requirement':
        this.detailModalContent = job[type] || 'No requirements available.';
        this.detailModalHeader = 'Requirements';
        break;
      case 'responsibility':
        this.detailModalContent = job[type] || 'No responsibilities available.';
        this.detailModalHeader = 'Responsibilities';
        break;
    }
    this.detailModalVisible = true;
  }
}
